import { render, staticRenderFns } from "./TemplateWidgetPanel.vue?vue&type=template&id=70143d43&scoped=true"
import script from "./TemplateWidgetPanel.vue?vue&type=script&lang=js"
export * from "./TemplateWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./TemplateWidgetPanel.vue?vue&type=style&index=0&id=70143d43&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70143d43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70143d43')) {
      api.createRecord('70143d43', component.options)
    } else {
      api.reload('70143d43', component.options)
    }
    module.hot.accept("./TemplateWidgetPanel.vue?vue&type=template&id=70143d43&scoped=true", function () {
      api.rerender('70143d43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/TemplateWidgetPanel.vue"
export default component.exports